import { IconButton } from "@mui/material";
import { observer } from "mobx-react";
import React from "react";
import { toast } from "react-toastify";
import { AppIcon } from "../utils/AppIcon";

interface Props {
  valor: string
  label: string
}

interface State {}

@observer
export class UserCopiavel extends React.Component<Props, State> {

  constructor(props) {
    super(props);
  }

  copiarSenha = () => {

    navigator.clipboard.writeText(this.props.valor || "");

    toast.success('Copiado!', {});

  };

  render() {

    const { valor, label = "Senha" } = this.props;

    return (
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginLeft: "1em", marginBottom: "0.5em" }}>

        <label style={{ minWidth: 60, marginBottom: 0 }}>{label}:</label>

        <input
          type={"text"}
          value={valor || ""}
          readOnly
          style={{ flex: 1, padding: 5, border: "1px solid #ccc", borderRadius: 4, fontSize: 13 }}
        />

        <IconButton onClick={this.copiarSenha} style={{ background: "none", border: "none", cursor: "pointer" }}>
          <AppIcon name="content_copy" size={20} style={{ color: "#2b82bc" }} />
        </IconButton>

      </div>
    );
  }
}
